export default function($) {
  function openSearch() {
    $('.js-search-overlay').attr('data-open', '');
    $('.js-search-overlay').attr('aria-hidden', 'false');
    $('.js-search-trigger').attr('aria-expanded', 'true');
    setTimeout(function() {
      $('.js-search-overlay').find('input').focus();
    }, 50);
  }

  function closeSearch() {
    $('.js-search-overlay').removeAttr('data-open');
    $('.js-search-overlay').attr('aria-hidden', 'true');
    $('.js-search-trigger').attr('aria-expanded', 'false');
    $('.js-search-trigger').first().trigger('focus');
  }

  $('.js-search-trigger').on('click', openSearch);

  $('.js-search-close').on('click', closeSearch);

  $(document).on('keydown', function(e) {
    if (e.key === 'Escape' && $('.js-search-overlay').is('[data-open]')) {
      closeSearch();
    }
  });

  $(document).on('click', function(e) {
    if (
      $('.js-search-overlay').is('[data-open]') &&
      ! $(e.target).closest('.js-search-overlay').length &&
      ! $(e.target).closest('.js-search-trigger').length
    ) {
      closeSearch();
    }
  });

  $(document).on('click', '.js-nav-mobile-open', function() {
    if ($('.js-search-overlay').is('[data-open]')) {
      closeSearch();
    }
  });
}
